import React from 'react';

export const AnalyticsProviderContext = React.createContext({
  track: () => {},
});
